import { ReportServiceInterface } from 'domain/services';
import { GetAllCoursesUserUseCaseInterface } from 'domain/services/courses/get-all-courses-user';
import {
  GetAllSemestersUserUseCaseInterface,
  ReportRadinoUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  reportRadino: ReportRadinoUseCaseInterface;
  getAllCoursesUser: GetAllCoursesUserUseCaseInterface;
  getAllSemestersUser: GetAllSemestersUserUseCaseInterface;
}

export class ReportService implements ReportServiceInterface {
  private readonly _reportRadino: ReportRadinoUseCaseInterface;
  private readonly _getAllCoursesUser: GetAllCoursesUserUseCaseInterface;
  private readonly _getAllSemestersUser: GetAllSemestersUserUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._reportRadino = usecases.reportRadino;
    this._getAllCoursesUser = usecases.getAllCoursesUser;
    this._getAllSemestersUser = usecases.getAllSemestersUser;
  }

  reportRadino(
    params: ReportRadinoUseCaseInterface.Params,
  ): Promise<ReportRadinoUseCaseInterface.Result> {
    return this._reportRadino.execute(params);
  }

  getAllCoursesUser(
    params: GetAllCoursesUserUseCaseInterface.Params,
  ): Promise<GetAllCoursesUserUseCaseInterface.Result> {
    return this._getAllCoursesUser.execute(params);
  }

  getAllSemestersUser(
    params: GetAllSemestersUserUseCaseInterface.Params,
  ): Promise<GetAllSemestersUserUseCaseInterface.Result> {
    return this._getAllSemestersUser.execute(params);
  }
}
